import { WebLicense, WebLicenseVendorSystem } from 'src/app/models/web-license.model';

// Apresentação de assento comum às telas de licença (chamado 0000577675).

export function webLicenseSystemName(item: {
  vendor_system?: WebLicenseVendorSystem | null;
  vendor_system_id?: number;
}): string {
  return (
    item.vendor_system?.system_name ||
    item.vendor_system?.name ||
    `Sistema ${item.vendor_system_id ?? item.vendor_system?.id ?? '?'}`
  );
}

/**
 * As quatro funções abaixo recebem um tipo estrutural (não `WebLicense` direto) de propósito: o
 * dashboard novo de licenças (chamado 0000579538) tem seu próprio `LicenseSeatRow`, que carrega os
 * mesmos campos de status mas uma `session` de formato diferente — e são exatamente esses quatro
 * campos que a apresentação de status precisa, nos dois tipos.
 */
interface WebLicenseStatusLike {
  status: WebLicense['status'];
  active: boolean;
  demo: boolean;
}

export function webLicenseStatusLabel(license: WebLicenseStatusLike): string {
  if (license.status === 'blocked') return 'Bloqueada';
  if (!license.active) return license.demo ? 'Inativa (cortesia vencida)' : 'Inativa';
  if (license.status === 'linked') return 'Vinculada';
  return 'Disponível';
}

export function webLicenseStatusClass(license: WebLicenseStatusLike): string {
  if (license.status === 'blocked') return 'badge bg-danger';
  if (!license.active) return 'badge bg-secondary';
  if (license.status === 'linked') return 'badge bg-primary';
  return 'badge bg-success';
}

/** Cor do `patron-badge` de status — mesmo critério de `webLicenseStatusClass`. */
export function webLicenseStatusColor(
  license: WebLicenseStatusLike
): 'danger' | 'secondary' | 'primary' | 'success' {
  if (license.status === 'blocked') return 'danger';
  if (!license.active) return 'secondary';
  if (license.status === 'linked') return 'primary';
  return 'success';
}

interface WebLicenseSessionLike {
  is_in_use: boolean;
  session?: { device_name?: string | null; ip_address?: string | null } | null;
}

export function webLicenseSessionLabel(license: WebLicenseSessionLike): string {
  if (!license.is_in_use) return 'Livre';
  const device = license.session?.device_name || license.session?.ip_address;
  return device ? `Em uso · ${device}` : 'Em uso';
}
